<div class="deletePopup" style="font-family: Poppins;">
    <app-loader *ngIf="isLoading"></app-loader>
    <div class="d-flex justify-content-between align-items-center p-10" style="background-color: #1363Df; color: white;">
        <h2 mat-dialog-title class="m-0 p-x-20">{{ 'Modify Details' }}</h2>

        <div class="p-2" style="margin: 0 0 -5px 0px !important;">
            <mat-icon mat-dialog-close class="close-icon" style="color: white;">close</mat-icon>
        </div>
    </div>
    <mat-dialog-content style="padding: 25px 30px;">
        <div *ngFor="let key of keyOrder">
            <p><strong>{{ key }}:</strong> {{ selectedData[key] }}</p>
        </div>
        <div class="schedule-fields" [formGroup]="scheduleForm">
            <mat-form-field appearance="fill">
              <mat-label>From Date & Time</mat-label>
      
              <!-- Combined read-only display -->
              <input matInput [value]="fromDateTimeDisplay" readonly (click)="fromDatePicker.open()">
      
              <!-- Hidden bound input to preserve formControl for fromDate -->
              <input matInput [matDatepicker]="fromDatePicker" [matDatepickerFilter]="dateFilterFrom" (dateChange)="selectFromDate($event)"
                formControlName="fromDate" style="display: none;" />
      
              <!-- Calendar Icon -->
              <button mat-icon-button matSuffix (click)="fromDatePicker.open()" type="button">
                <mat-icon>calendar_today</mat-icon>
              </button>
      
              <!-- Time Selector Icon -->
              <button mat-icon-button matSuffix  #fromTimeMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="fromTimeMenu" 
                (click)="generateFromTimeSlots()" type="button">
                <mat-icon>access_time</mat-icon>
              </button>
              <mat-hint align="start" *ngIf="!isSameDate">
                <button mat-button color="primary" class="btn mat-hint-span" (click)="setCurrentTime('from')">Current Date Time</button>
              </mat-hint>
      
              <!-- Datepicker -->
              <mat-datepicker #fromDatePicker (dateChange)="selectFromDate($event)"
                [matDatepickerFilter]="dateFilterFrom"></mat-datepicker>
            </mat-form-field>
      
            <!-- Time options menu -->
            <mat-menu #fromTimeMenu="matMenu">
              <button mat-menu-item *ngFor="let time of fromTimeSlots" [disabled]="time.disabled"
                (click)="onTimeOptionSelected(time)">
                {{ time.label }}
              </button>
            </mat-menu>
      
            <!-- TO DATE & TIME FIELD -->
            <mat-form-field appearance="fill">
              <mat-label>To Date & Time</mat-label>
      
              <!-- Combined read-only display -->
              <input matInput [value]="toDateTimeDisplay" readonly (click)="toDatePicker.open()">
      
              <!-- Hidden input to bind formControl for toDate -->
              <input matInput [matDatepicker]="toDatePicker" [matDatepickerFilter]="dateFilterTo" formControlName="toDate" (dateChange)="selectToDate($event)"
                style="display: none;" />
      
              <!-- Calendar icon -->
              <button mat-icon-button matSuffix (click)="toDatePicker.open()" type="button">
                <mat-icon>calendar_today</mat-icon>
              </button>
      
              <!-- Time selector icon -->
              <button mat-icon-button matSuffix #toTimeMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="toTimeMenu" (click)="generateToTimeSlots()"
                type="button">
                <mat-icon>access_time</mat-icon>
              </button>
              <mat-hint align="start" *ngIf="isSameDate">
                <button mat-button color="primary" class="btn mat-hint-span" (click)="setCurrentTime('to')">Current Date Time</button>
              </mat-hint>
      
              <!-- Datepicker -->
              <mat-datepicker #toDatePicker (dateChange)="selectToDate($event)" [dateFilter]="dateFilterTo"></mat-datepicker>
            </mat-form-field>
      
            <!-- TO TIME MENU -->
            <mat-menu #toTimeMenu="matMenu">
              <button mat-menu-item *ngFor="let time of toTimeSlots" [disabled]="time.disabled"
                (click)="onToTimeSelected(time)">
                {{ time.label }}
              </button>
            </mat-menu>
      
          </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="pt-0">
        <button mat-flat-button class="btn du-custom-confirm-btn" (click)="closeDialog(true)">Save</button>
        <button mat-flat-button class="btn du-transparent-btn" (click)="closeDialog(false)">Cancel</button>
    </mat-dialog-actions>
</div>